import { render, staticRenderFns } from "./btn_muda_status_data.vue?vue&type=template&id=2bc42432&"
import script from "./btn_muda_status_data.vue?vue&type=script&lang=js&"
export * from "./btn_muda_status_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc42432')) {
      api.createRecord('2bc42432', component.options)
    } else {
      api.reload('2bc42432', component.options)
    }
    module.hot.accept("./btn_muda_status_data.vue?vue&type=template&id=2bc42432&", function () {
      api.rerender('2bc42432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/pagamento/btn_muda_status_data.vue"
export default component.exports